import { useMemo } from "react";
import useDevice from "src/hooks/useDevice";
import { paddingLarge, paddingXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import usePhotoDetailDim from "./usePhotoDetailDim";

const useImageGalleryDimensions = () => {
	const safeArea = useSafeArea();
	const { device } = useDevice();
	const dim = usePhotoDetailDim();

	const mainItemDimensions = useMemo(() => {
		return {
			width: dim.width - (safeArea.left + safeArea.right),
			// No safe area deduction to allow zoomed content to overlap with safeArea
			height: dim.height,
			spacing: device === "desktop" ? 0 : 10,
		};
	}, [device, dim.height, dim.width, safeArea.left, safeArea.right]);
	const carouselItemDimensions = useMemo(() => {
		return {
			width: 45,
			height: 60,
			spacing: 1,
			paddingVertical: device === "desktop" ? paddingXL : paddingLarge,
		};
	}, [device]);
	return {
		carouselItemDimensions,
		mainItemDimensions,
	};
};
export default useImageGalleryDimensions;
